import { T } from './reportTokens';

type Props = {
    /** Lower-cased name of the section — e.g. "sales by channel". Used in the message. */
    kpiName: string;
    /** 'small' fits inside tight cards; 'medium' for tables / larger panels. Defaults to 'small'. */
    size?: 'small' | 'medium';
    /** Optional custom height for the centering container. */
    minHeight?: number;
};

const SectionEmpty = ({ kpiName, size = 'small', minHeight }: Props) => {
    const isMedium = size === 'medium';
    const iconSize = isMedium ? 32 : 24;
    const textSize = isMedium ? 14 : 13;
    const containerMinHeight = minHeight ?? (isMedium ? 200 : 120);
    const gap = isMedium ? 12 : 8;

    return (
        <div
            style={{
                flex: 1,
                minHeight: containerMinHeight,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap,
                padding: '20px 12px',
                fontFamily: T.font,
                textAlign: 'center',
            }}
        >
            <svg
                aria-hidden
                width={iconSize}
                height={iconSize}
                viewBox="0 0 24 24"
                fill="none"
                stroke={T.t3}
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <path d="M3 20h18" />
                <rect x="4" y="12" width="3" height="8" rx="1" />
                <rect x="10.5" y="7" width="3" height="13" rx="1" />
                <rect x="17" y="4" width="3" height="16" rx="1" />
            </svg>
            <div style={{ fontSize: textSize, color: T.t3, lineHeight: 1.45 }}>
                No {kpiName} data for this period
            </div>
        </div>
    );
};

export default SectionEmpty;
